<template>
  <div class="forget">
    <a-card style="width: 60%; margin: 50px auto">
      <div
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        ">
        忘记密码
      </div>
      <a-form :model="formData" layout="inline" class="form-class">
        <a-form-item required  label="用户名"  class="form-margin">
          <a-row >
            <a-col :span="18" >
              <a-input
                v-model:value="formData.username"
                placeholder="请输入用户名"
                style="width: 250px "
              ></a-input>
            </a-col>
            <a-col :span="6">
              <a-button @click="sendInfo">点击发送验证码</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
        required 
          label="验证码"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input
                v-model:value="formData.encode"
                placeholder="请输入验证码"
                style="width: 572px"
              ></a-input>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
        required 
          label="新密码"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input-password
                v-model:value="formData.password"
                placeholder="请输入新密码"
                style="width: 572px"
              ></a-input-password>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
        required 
          label="再次输入"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input-password
                v-model:value="formData.isPassword"
                placeholder="请输入重复密码"
                style="width: 572px"
              ></a-input-password>
            </a-col>
          </a-row>
        </a-form-item>
        <a-row class="dban">
          <a-col style="checked: ref(false)">
            <a-button @click="cancelpass">取消</a-button>
          </a-col>
          &nbsp;&nbsp;&nbsp;
          <a-col :span="50">
            <a-button @click="onSubmit" type="primary" class="submit-class"> 确定 </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { message } from 'ant-design-vue';
import { password,sendEmail,checkCode,reSetPwd } from '../../utils/api'
export default defineComponent({
  setup() {
    const formData = reactive({
      username: "",
      encode: "",
      password: "",
      isPassword: "",
    });
    return {
      formData,
    };
  },
  methods:{
        onSubmit(){
          checkCode({code:this.formData.encode,userName:this.formData.username}).then(res=>{
            if(res.code==200){
              if(this.formData.isPassword!=this.formData.password){
                 message.error('两次密码不正确');
              }else{
                reSetPwd({code:this.formData.encode,userName:this.formData.username,newPassword: this.formData.isPassword}).then(res=>{
                    if(res.code==200){
                      message.info('密码修改成功');
                      this.$router.push('indexLogin')
                    }
                })
              }
              
            }
          })
        },
        cancelpass(){
          this.$router.push({path:'indexLogin'})
        },
        sendInfo(){
          sendEmail(this.formData.username).then(res=>{
            if(res.code==200){
                message.info('验证码已发送邮箱');
            }
          })
        }
  }
});
</script>

<style lang="scss" scoped>
.forget{
  /deep/.ant-form-item-label{
    width: 100px;
  }
   .hoverBottom1{
      position: relative;
      // width:100%;
      // text-align:center;
      //  padding:20px 0;
      width:fit-content;
      display: inline-block;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  .form-class {
    display: flex;
    flex-direction: column;
  }
  .ant-row{
    text-align: left;
  }
  .form-margin {
    margin: 25px 20px 0 20px;
  }
  .dban {
    margin: 15px;
    margin-left: 510px ;
  }
  .ant-card{
    margin-top: 20px;
  }
}

</style>